import { Directive, ElementRef } from '@angular/core';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';

@Directive({
  selector: '[custom-bg-inactive-color]' // Attribute selector
})
export class CustomBgInactiveColorDirective {

  constructor(private el: ElementRef, private colorProvider: ColorProvider, events: Events) {
    
    this.update();

    events.subscribe('color:updated', () => {
      this.update();
    });
  }

  update() {
    this.colorProvider.getInactiveColor().then( color => this.el.nativeElement.style.backgroundColor = color);
  }

}



// WEBPACK FOOTER //
// ./src/directives/custom-bg-inactive-color/custom-bg-inactive-color.ts